import { getArtDirection } from "./artDirection.js";
import { defaultSurfStyle } from "../model/defaultStyle.js";
import { styleFromPreset } from "./presets.js";
export function cloneSurfStyle(style) {
    return structuredClone(style);
}
export function applyPresetToDeckTheme(current, presetId, presentationType) {
    const next = styleFromPreset(presetId, presentationType ?? current.presentationType);
    return {
        ...next,
        styleRefS3Key: current.styleRefS3Key,
        previewS3Key: current.previewS3Key,
    };
}
export function mergeSurfStyle(base, patch) {
    return {
        ...base,
        ...patch,
        palette: patch.palette ? { ...base.palette, ...patch.palette } : base.palette,
        fonts: patch.fonts ? { ...base.fonts, ...patch.fonts } : base.fonts,
        textRoles: patch.textRoles ? { ...base.textRoles, ...patch.textRoles } : base.textRoles,
        legibility: patch.legibility
            ? {
                ...base.legibility,
                ...patch.legibility,
                scrim: patch.legibility.scrim
                    ? { ...base.legibility.scrim, ...patch.legibility.scrim }
                    : base.legibility.scrim,
                safeZones: patch.legibility.safeZones ?? base.legibility.safeZones,
            }
            : base.legibility,
        artDirection: patch.artDirection
            ? {
                ...getArtDirection(base),
                ...patch.artDirection,
            }
            : base.artDirection,
    };
}
/** Relative luminance heuristic for autoContrast on sample preview. */
export function isDarkHex(hex) {
    const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
    if (!m)
        return false;
    const n = parseInt(m[1], 16);
    const r = (n >> 16) & 255;
    const g = (n >> 8) & 255;
    const b = n & 255;
    const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return lum < 0.45;
}
export function resolveRoleColor(style, role) {
    const roleColor = style.textRoles[role]?.color;
    if (!style.legibility.autoContrast)
        return roleColor;
    const darkBg = isDarkHex(style.palette.surface);
    if (darkBg && isDarkHex(roleColor))
        return style.palette.text;
    if (!darkBg && !isDarkHex(roleColor))
        return style.palette.text;
    return roleColor;
}
export function ensureSurfStyle(style) {
    const base = defaultSurfStyle();
    if (!style)
        return base;
    return mergeSurfStyle(base, style);
}
